if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });

        // Delivery callout logic
        this.deliveryCallout = document.querySelector('.delivery-callout');
        if (this.deliveryCallout) {
          this.calloutText = this.deliveryCallout.querySelector('.delivery-callout__text');
          this.cutoffHours = this.deliveryCallout.dataset.cutoffHours;
          this.cutoffMinutes = this.deliveryCallout.dataset.cutoffMinutes;
          this.leadTime = parseInt(this.deliveryCallout.dataset.leadTime, 10);

          const cutOff = new Date();
          cutOff.setHours(this.cutoffHours, this.cutoffMinutes, 0, 0);

          this.cutOff = cutOff; // Store the cutoff time
          this.deliveryDateString = this.calculateDeliveryDate(this.leadTime);

          this.updateCountdown(); // Initial update
          this.timerInterval = setInterval(this.updateCountdown(), 5000); // Update every 5 seconds
        }
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      calculateDeliveryDate(leadTime) {
        let deliveryDate = new Date();
        let daysToAdd = leadTime;

        while (daysToAdd > 0) {
          deliveryDate.setDate(deliveryDate.getDate() + 1);
          const dayOfWeek = deliveryDate.getDay();
          // Only count weekdays (Monday-Friday)
          if (dayOfWeek !== 0 && dayOfWeek !== 6) {
            daysToAdd--;
          }
        }

        return deliveryDate.toLocaleDateString('en-GB', {
          weekday: 'long',
        });
      }

      updateCountdown() {
        const now = new Date();
        const diff = this.cutOff - now;
        
        // Check if current day is weekend
        const currentDay = now.getDay();
        const isWeekend = currentDay === 0 || currentDay === 6;

        if (diff <= 0 || isWeekend) {
          // If cutoff time has passed or it's weekend, show next available delivery date
          this.deliveryDateString = this.calculateDeliveryDate(this.leadTime);
          this.calloutText.textContent = 'Receive it by ' + this.deliveryDateString;
          clearInterval(this.timerInterval);
          return;
        }

        const hours = Math.floor(diff / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

        this.calloutText.textContent = `Order within ${hours ? hours + ' hrs and' : ''} ${minutes ? minutes + ' mins' : ''} & receive it tomorrow!`;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}
